/* eslint-disable no-unused-expressions */
import { pascalCase } from "pascal-case";
import slugify from "slugify";
import mixpanel from "mixpanel-browser";

const TRACKINGLESS_PARAM = "trackingless";

const isPageTrackingless = (query) => query && query.ver === TRACKINGLESS_PARAM;

const trackGtm = (eventData) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventData[1],
      section: eventData[0],
      element: eventData[2],
    });
  }
};

const trackMixpanel = (eventName, mixpanelOptions = {}) => {
  mixpanel.track(eventName, mixpanelOptions);
};

const trackEvents = ({ gtmEvent, mixpanelEvent, mixpanelOptions = {} }) => {
  gtmEvent && trackGtm(gtmEvent);
  mixpanelEvent && trackMixpanel(mixpanelEvent, mixpanelOptions);
};

const trackClickEvent = (section, element) => {
  if (!section || !element) return;

  const event = "clicked";
  trackEvents({ gtmEvent: [pascalCase(section), event, pascalCase(element)] });
};

const buildTrackingBasedId = (section, element, suffix) => {
  const elementSuffix = suffix ? `-${suffix}` : "";
  const trackingId = `${section}-${element}${elementSuffix}`;
  const buttonIdSlugified = slugify(trackingId, { lower: true });

  return section && element ? buttonIdSlugified : null;
};

export { trackEvents, trackMixpanel, isPageTrackingless, trackClickEvent, buildTrackingBasedId };
